import React, { createContext, useContext, useEffect, useState } from "react";

// Upload Context 創建
const UploadContext = createContext();

// 提供者組件
export const UploadProvider = ({ children }) => {
  // const [uploadData, setUploadData] = useState({
  //   access: "",
  //   client: "",
  //   project: "",
  //   fileName: "", // 儲存檔案名稱
  //   file: "",
  // });
  const [uploadData, setUploadData] = useState([]);
  const [uploadAttachments, setUploadAttachments] = useState([]);

  const updateUploadData = (newEntries) => {
    setUploadData((prev) => {
      const fileMap = new Map(prev.map((entry) => [entry.fileName, entry])); // 用檔案名稱作為鍵
      newEntries.forEach((entry) => {
        fileMap.set(entry.fileName, entry); // 覆蓋舊的檔案
      });
      return Array.from(fileMap.values()); // 返回更新後的檔案列表
    }); // 合併新檔案到現有列表
  };
  
  const updateUploadAttachments = (newEntries) => {
    setUploadAttachments((prev) => {
      const fileMap = new Map(prev.map((entry) => [entry.fileName, entry])); // 用檔案名稱作為鍵
      newEntries.forEach((entry) => {
        fileMap.set(entry.fileName, entry); // 覆蓋舊的檔案
      });
      return Array.from(fileMap.values()); // 返回更新後的檔案列表
    }); // 合併新檔案到現有列表
  };

  // useEffect(()=>{
  //   console.log("uploadAttachments:",uploadAttachments)
  // },[uploadAttachments])

  const [uploadStatus, setUploadStatus] = useState(""); // 用於管理上傳狀態

  // // 提供更新函數，支持局部更新
  // const updateUploadData = (fieldOrData, value) => {
  //   if (typeof fieldOrData === "object") {
  //     // 更新整個對象
  //     setUploadData((prev) => ({
  //       ...prev,
  //       ...fieldOrData,
  //     }));
  //   } else {
  //     // 單個欄位更新
  //     setUploadData((prev) => ({
  //       ...prev,
  //       [fieldOrData]: value,
  //     }));
  //   }
  //   console.log(uploadData);
  // };

  return (
    <UploadContext.Provider value={{
      uploadData,updateUploadData,
      uploadStatus, // 確保上傳狀態被傳入
      setUploadStatus, // 確保更新狀態的函數被傳入
      uploadAttachments, updateUploadAttachments, setUploadAttachments
    }}>
      {children}
    </UploadContext.Provider>
  );
};

// 自定義 Hook
export const useUploadContext = () => useContext(UploadContext);
